module.exports = "/labor-cost/components/laborCostNoAccess-e4be30.html";